import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import { InputSelector } from "../input_selector";
import { SELECTOR_GROUP_TYPE } from "../../core/_utils/constants";
//import { InputSelectorDuid } from "../input_selector_duid";

const InputControl = ({
  groupType,
  controlType,
  selectionMode,
  options,
  selectedValues,
  disabledValues,
  onChange
}) => {
  const onChangeSelectorValues = newValue => {
    if (!Array.isArray(newValue)) newValue = [newValue];
    onChange(newValue);
  };

  return (
    <div>
      {controlType === "elements" ? (
        <Select
          mode={selectionMode}
          style={{ width: "100%" }}
          showSearch
          placeholder={"type or select from list"}
          optionFilterProp={"text"}
          value={selectedValues}
          onChange={onChangeSelectorValues}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) ===
            0
          }
        >
          {options.map(o => (
            <Select.Option
              key={o.value}
              value={o.value}
              disabled={disabledValues && disabledValues.indexOf(o.value) >= 0}
            >
              {o.text}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <InputSelector
          selectionMode={selectionMode}
          options={options}
          selectedValues={selectedValues}
          disabledValues={disabledValues}
          onChange={onChangeSelectorValues}
          collapseAtCount={groupType === SELECTOR_GROUP_TYPE.UNIT ? 17 : 9} // Numbers here are not random, Brett had logical reasons for these.
        />
      )}
    </div>
  );
};

InputControl.propTypes = {
  groupType: PropTypes.string.isRequired,
  controlType: PropTypes.string.isRequired,
  selectionMode: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  disabledValues: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

export default InputControl;



// WEBPACK FOOTER //
// ./src/views/components/input_control/InputControl.jsx